<template>
  <div>
    <button class="mylisting-button dark-button" @click="showAddAdminModal()">Add Administrator</button>
    <table class="table table-striped mt-2">
      <thead class="" style="background-color: var(--coredarkcolor); color: var(--corelightcolor);">
        <tr class="">
          <th scope="col">Name</th>
          <th scope="col">Email</th>
          <th scope="col">Classification</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in agents" :key="user.id" style="cursor: pointer;">
        <!-- <tr v-for="user in filteredCandidates" :key="user.id" @click="deleteUser(user.id)" style="cursor: pointer;"> -->
          <td @click="showAgentModal(user)">
            {{ user.first_name }} {{ user.last_name }}
          </td>
          <td @click="showAgentModal(user)">
            {{ user.email }}
            <!-- {{ user.status }} -->
          </td>
          <td @click="showAgentModal(user)">
            {{ user.category }}
            <!-- <button class="btn btn-danger" @click="deleteUser(user)">Delete</button> -->
            <!-- <button class="btn btn-danger" @click="setteam(user)">Set Team Status</button> -->
            <!-- <button class="mylisting-button dark-button" @click="unadminify(user)">Unadminify</button> -->
            <!-- <button class="mylisting-button dark-button" @click="setCategory(user)">Set Category</button> -->
            <!-- <button class="mylisting-button dark-button" @click="setPassword(user)">Set Password</button> -->
          </td>
          <td @click.self.prevent="showAgentModal(user)">
            <button class="mylisting-button dark-button" @click="updatePassword(user)">Update Password</button>
          </td>
        </tr>
      </tbody>
    </table>

    <modal name="admin-panel-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">

        <div class="row" style="margin-bottom: 30px;">
          <div class="col dashboard-button text-center" :class="{ 'dashboard-button-active': tab == 'admin' }" @click="tab = 'admin'">
            Admin
          </div>
        </div>

        <div>
          <panel :passedUser="agent" @userUpdated="userUpdated()"></panel>
        </div>

        <hr>
          <button class="mylisting-button danger-button" @click="showDeleteUserModal(agent)">Delete</button>
      </div>
    </modal>

    <modal name="add-admin-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5 field-of-fields">
        <h2 v-if="!agent.email">Add Admin</h2>
        <h2 v-if="agent.email">Edit Admin</h2>
        <hr>
        <label class="top-label">Email*</label>
        <input type="text" class="form-control" v-model="email">
        <label class="">First Name</label>
        <input type="text" class="form-control" v-model="firstName">
        <label class="">Last Name</label>
        <input type="text" class="form-control" v-model="lastName">
        <label>Access Level*</label>
        <multiselect
          class="mb-2 w-100"
          v-model="category"
          :options="categories"
          :multiple="false"
          :searchable="true"
          :close-on-select="true"
          :show-labels="false"
          placeholder="Select Access Level"
          :max-height= "150"
        ></multiselect>
        <hr>
        <button class="mylisting-button secondary-button" @click="cancelChanges()">Cancel</button>
        <button class="mylisting-button danger-button" @click="showDeleteUserModal(agent)" v-if="agent.email">Delete</button>
        <button class="mylisting-button dark-button" @click="addAdmin()" v-if="!agent.email && email && category" style="float: right;">Add</button>
        <button  class="mylisting-button dark-button" @click="editAdmin()" v-if="agent.email" style="float: right;">Save</button>
      </div>
    </modal>

    <modal name="missing-fields-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h3>Please make sure an email is entered and an access level is selected.</h3>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('missing-fields-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="change-password-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h3>Please enter a new password.</h3>
        <label class="top-label">Password*</label>
        <input type="text" class="form-control" v-model="password">
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('change-password-modal')" style="">Cancel</button>
        <button class="mylisting-button dark-button" @click="savePassword()" v-if="password" style="float: right;">Save</button>
      </div>
    </modal>

    <modal name="password-reset-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Password reset to {{ this.password }}</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('password-reset-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="delete-agent-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h3>Are you sure you want to delete this user?</h3>
        <!-- <p>{{ user.first_name }} {{ user.last_name }}</p> -->
        <p>{{ agent.email }}</p>
        <hr>
        <button class="mylisting-button secondary-button" @click="hideDeleteUserModal()" style="">Cancel</button>
        <button class="mylisting-button danger-button" @click="deleteUser(agent)" style="float: right;">Delete</button>
      </div>
    </modal>

    <modal name="confirm-deleted-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Administrator deleted!</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('confirm-deleted-modal')" style="">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'
import Panel from '../Panel'

export default {
  components: {
    Panel,
  },
  data() {
    return {
      agents: {},
      agent: {},
      tab: '',

      email: '',
      firstName: '',
      lastName: '',
      categories: ['global', 'candidates'],
      category: '',
      password: '',
    }
  },
  created() {
    this.getAgents()
  },
  methods: {
    getAgents() {
      axios.get('/api/people/?is_agent=true&agency='+this.$store.getters.agencyID.toString())
        .then(res => {
          console.log(res)
          this.agents = res.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    setteam(user) {
      axios.patch('/api/people/'+user.id.toString()+'/', {
        status: 'team'
      })
        .then(res => {
          console.log(res)
          this.getAgents()
        })
        .catch(error => {
          console.log(error)
        })
    },
    showAgentModal(agent) {
      this.agent = agent
      // this.tab = 'admin'
      // this.$modal.show('admin-panel-modal')

      // console.log(this.agent)
      this.firstName = agent.first_name
      this.lastName = agent.last_name
      this.email = agent.email
      this.category = agent.category
      this.$modal.show('add-admin-modal')
    },
    showAddAdminModal() {
      this.email = ''
      this.category = ''
      this.firstName = ''
      this.lastName = ''
      this.$modal.show('add-admin-modal')
    },
    unadminify(user) {
      //
      // Function for converting an admin account into a candidate account (just a workaround, not in production use)
      //
      axios.patch('/api/people/'+user.id.toString()+'/', {
        is_agent: false,
        is_candidate: true,
      })
        .then(res => {
          console.log(res)
          this.getAgents()
        })
        .catch(error => {
          console.log(error)
        })
    },
    setCategory(user) {
      axios.patch('/api/people/'+user.id.toString()+'/', {
        category: 'global'
        // category: 'candidates'
      })
        .then(res => {
          console.log(res)
          this.getAgents()
        })
        .catch(error => {
          console.log(error)
        })
    },
    addAdmin() {
      axios.post('/create-user/', {
        email: this.email,
        password: this.email,
        agency: this.$store.getters.agencyID,
      })
        .then(res => {
          axios.patch('/api/people/'.concat(res.data.pk.toString())+'/',
            {
              agency: this.$store.getters.agencyID,
              agency_owner: this.$store.getters.agencyName,
              // user_type: authData.user_type,
              // is_employer: this.is_employer,
              // is_candidate: this.is_candidate,
              is_agent: true,
              // status: 'New',
              // status: authData.status,
              // numberArray: [0, 0, 0, 0],
              category: this.category,
              first_name: this.firstName,
              last_name: this.lastName,
            }
          )
            .then(res => {
              console.log(res)

              this.getAgents()
              this.$modal.hide('add-admin-modal')
            })
            .catch(error => console.log(error))
        })
    },
    editAdmin() {
      if (this.email && this.category) {
        axios.patch(`/api/people/${this.agent.id}/`, {
          email: this.email,
          category: this.category,
          first_name: this.firstName,
          last_name: this.lastName
        })
          .then(res => {
            this.getAgents()
            this.$modal.hide('add-admin-modal')
          })
          .catch(error => console.log(error))
      } else {
        this.$modal.show('missing-fields-modal')
      }
    },
    cancelChanges() {
      this.agent = {}
      this.$modal.hide('add-admin-modal')
    },
    setPassword(user) {
      axios.post('/optimum/manual-reset-password/', {
        user_id: user.id,
        password: 'ChyanneRox@2020',
      })
        .then(res => {
          console.log(res)
          // this.$modal.show('password-reset-modal')
        })
        .catch(error => {
          console.log(error)
        })
    },
    showDeleteUserModal(user) {
      this.agent = user
      this.$modal.show('delete-agent-modal')
    },
    hideDeleteUserModal() {
      this.$modal.hide('delete-agent-modal')
    },
    deleteUser(user) {
      // console.log('Deleting User: '.concat(user.id.toString()))
      axios.delete('/api/people/'.concat(user.id.toString()).concat('/'))
        .then(res => {
          console.log(res)
          // if (user.is_candidate) {
          //   this.getCandidates()
          // }
          // else if (user.is_employer) {
          //   this.getEmployers()
          // }
          this.getAgents()
          this.$modal.show('confirm-deleted-modal')

          // this.hideDeleteModal()
          // this.closeCandidateModal()
          // this.$modal.hide('candidate-modal')
          this.$modal.hide('add-admin-modal')
          this.hideDeleteUserModal()
        })
        .catch(error => console.log(error))
    },
    updatePassword(agent) {
      this.agent = agent
      this.$modal.show('change-password-modal')
      this.$modal.hide('add-admin-modal')
    },
    savePassword() {
      axios.post('/optimum/manual-reset-password/', {
        user_id: this.agent.id,
        password: this.password,
      })
        .then(res => {
          // console.log(res)
          this.$modal.show('password-reset-modal')
          this.$modal.hide('change-password-modal')
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
<style>
  .table td {
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/agents/tables/Agents.vue